import Heading from '@commons/Heading/Heading';

/**
 * Blurb title component with configurable heading level.
 */
export default function BlurbTitle({ level = 3, children, className = '' }) {
  if (!children) return null;

  return (
    <Heading level={level} className={`Blurb__title ${className}`}>
      {children}
    </Heading>
  );
}
